import { createContext } from "react";

const UploadContentContext = createContext();

export default UploadContentContext;